var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationMenuCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.75952,
    y1: 8.7063,
    x2: 21.6094,
    y2: 21.5562,
    stroke: "#714FFF",
    strokeWidth: 2.59606,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.7383,
    y1: 8.5752,
    x2: 8.88842,
    y2: 21.4251,
    stroke: "#714FFF",
    strokeWidth: 2.59606,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMenuCross);
export default __webpack_public_path__ + "static/media/NavigationMenuCross.34a6bce1babc974e25611e01f0114245.svg";
export { ForwardRef as ReactComponent };